// @flow

import styled, { css } from 'styled-components';

const composeStyles = ({ pageCentered, componentCentered }) => {
  let width = '16px';
  let height = '16px';
  let top = 'auto';
  let left = 'auto';
  let position = 'static';
  let alignSelf = 'initial';
  let justifySelf = 'initial';
  let alignItems = 'initial';
  let justifyContent = 'initial';

  if (pageCentered) {
    width = '16px';
    height = '16px';
    top = 'calc(50% - 8px)';
    left = 'calc(50% - 8px)';
    position = 'fixed';
    alignSelf = 'center';
    justifySelf = 'center';
  }

  if (componentCentered) {
    width = 'auto';
    height = 'auto';
    alignItems = 'center';
    justifyContent = 'center';
  }

  return css`
    width: ${width};
    height: ${height};
    top: ${top};
    left: ${left};
    position: ${position};
    align-self: ${alignSelf};
    justify-self: ${justifySelf};
    align-items: ${alignItems};
    justify-content: ${justifyContent};
    display: flex;
  `;
};

const LoadingWowWrapper = styled.div`
  ${composeStyles};
`;

export default LoadingWowWrapper;
